import Axios from "@/plugins/axios";
import { LOGIN, REFRESH_TOKEN, LOGOUT, REGISTER, NETWORK_ERROR, ROLES } from "@/api/endpoints";

export const TOKEN_KEY = "darwio_auth";

export const login = (authData) => {
  const user = {
    email: authData.email,
    password: authData.password,
  };

  return Axios.post(LOGIN, {
    ...user,
    validateStatus: () => true,
  });
};


export const register = (payload) => {
  return Axios.post(REGISTER, payload, {
    validateStatus: () => true,
  });
};

export const refreshToken = () => {
	return Axios.post(REFRESH_TOKEN,{}, {withCredentials: true}, {
	  validateStatus: () => true,
	});
  };

export const logout = () => {
  return Axios.post(LOGOUT, {
    validateStatus: () => true,
  });
};

export const fetchRoles = async (token) => {
  try {
    const response = await Axios.get(ROLES, {
      headers: { Authorization: `Bearer ${token}` },
      validateStatus: () => true,
    });
    return response;
  } catch (error) {
    return NETWORK_ERROR;
  }
};
